<template>
	<div style="padding-top: 15px;" v-if="CommentsData">
		<div class="comment-preview">
			<div class="item">
			{{$t('总计')}}<span class="c-span text-danger"> {{CommentsData.length}} </span>{{$t('条评论')}}
			</div>
			<div class="item sku-score">
				<span>{{$t('商品评分')}}：</span>
				<el-rate
				  v-model="average_score"
				  disabled
				  :colors="colors"
				  text-color="#FC686F"
				  score-template="{value}">
				</el-rate>
			</div>
		</div>
		<div class="layui-form comment-layui-form" >
			<div class="comment-filter">
				<div class="flex-col">
					<el-radio-group v-model="status" @change="statusChange">
					    <el-radio :label="5">{{$t('全部')}}</el-radio>
					    <el-radio :label="1">{{$t('好评')}}</el-radio>
					    <el-radio :label="2">{{$t('中评')}}</el-radio>
					    <el-radio :label="3">{{$t('差评')}}</el-radio>
					    <el-radio :label="4">{{$t('有图')}}</el-radio>
					  </el-radio-group>
				</div>
				<el-select v-model="sort_status" size="small" :placeholder="$t('按默认')" @change="sortChange">
					<el-option
					v-for="item in options"
					:key="item.value"
					:label="$t(item.label)"
					:value="item.value">
					</el-option>
				</el-select>
			</div>
		</div>
		<div class="comment-cells">
			<div class="comment-cell" v-for="(item,index) in CommentsData" :key="index">
				<div class="comment-cell_left">
					<div class="comment-cell_avatar">
						<img src="@/assets/images/default-avatar.png" alt="" />
					</div>
					<div class="header_name">
						<span>{{item.user_name}}</span>
					</div>
				</div>
				<div class="comment-cell_right">
					<div class="comment-raty">
						<el-rate
						  v-model="item.star"
						  disabled
						  :colors="colors"
						  text-color="#FC686F"
						  >
						</el-rate>
					</div>
					<div class="comment-item">
						{{item.created_at}} ｜ {{item.spec_sku}}
					</div>
					<div class="comment-item">
						{{item.content}}
					</div>
					<ul class="comment-pic" v-if="item.pic && item.pic.length > 0">
						<li v-for="(item2,index2) in item.pic">
							<img :src="item2" @click="openDialog(item2)" />
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="ui-page" v-if="total>10">
			<el-pagination
				background
				:small="isMobileFlag"
				:pager-count="5"
				layout="prev, pager, next"
				:current-page.sync="currentPage"
				@current-change="handleSizeChange"
				:page-size="listLimit"
				:total="total"
			  ></el-pagination>
		</div>
		<el-dialog top="10vh" :width="isMobileFlag?'100%':'50%'" :visible.sync="dialogVisible"  @close="closeDialog">
		      <img :src="currentImage" alt="" style="width: 100%; height: auto;" />
		</el-dialog>
	</div>
</template>
<script>
	import {
		goods_evaluate_api,
	} from "@/api/index"
	export default {
		props: {
			pid: {
				type: String,
			}
		},
		data() {
			return {
				dialogVisible:false,
				currentImage: '',
				colors: ['#FC686F','#FC686F','#FC686F', '#FC686F'],
				options: [{
				value: '1',
				label: '时间降序'
				}, {
				value: '2',
				label: '时间升序'
				}],
				status:5,
				sort_status: '1',
				CommentsData:null,
				average_score:0,
				total:0,
				currentPage: 1,
				listPage: 1,
				listLimit: 10
			};
		},
		methods:{
			openDialog(image) {
			  this.currentImage = image; // 设置当前要显示的图片
			  this.dialogVisible = true; // 显示弹出框
			},
			closeDialog() {
			  this.dialogVisible = false; // 关闭弹出框
			  this.currentImage = ''; // 清空当前图片
			},
			statusChange(e){
				this.status = e
				this.getEvaluate();
			},
			sortChange(e){
				this.sort_status = e
				this.getEvaluate();
			},
			async getEvaluate() {
				let data = {
					id:	this.pid,
					page:this.listPage,
					limit:this.listPage == 1 ? 10 : this.listLimit,
					status:this.status == 5 ? 0 : this.status,
					sort_status:this.sort_status
				}
				await goods_evaluate_api(data).then(res => {
					if (res && res.data.code == 1) {
						this.average_score = res.data.data.average_score
						this.CommentsData = res.data.data.lists
						this.total = res.data.data.total
					}
				});
			},
			handleSizeChange(e) {
			  this.listPage = e;
			  this.getEvaluate();
			},
		},
		mounted() {
			this.getEvaluate()
		}
	}
</script>
<style >
	.c-span{
		padding:0 6px;
	}
</style>